import {
  AMBER,
  BLUE,
  CYAN,
  DEEP_ORANGE,
  DEEP_PURPLE,
  GREEN,
  INDIGO,
  PINK,
  DARK_AMBER,
  DARK_BLUE,
  DARK_CYAN,
  DARK_DEEP_ORANGE,
  DARK_DEEP_PURPLE,
  DARK_GREEN,
  DARK_INDIGO,
  DARK_PINK,
} from 'constants/ThemeColors';

import backoffice from './backoffice';
import cadastros from './cadastros';
import cobranca from './cobranca';
import comercial from './comercial';
import configuracoes from './configuracoes';
import dashboards from './dashboards';
import financeiro from './financeiro';
import relatorios from './relatorios';
import digital from './digital';

const MODULO_PADRAO = {
  itens: cobranca,
  tema: { claro: BLUE, escuro: DARK_BLUE },
};

const MODULOS = {
  '/app/cob': MODULO_PADRAO,
  '/app/cad': {
    itens: cadastros,
    tema: { claro: CYAN, escuro: DARK_CYAN },
  },
  '/app/fin': {
    itens: financeiro,
    tema: { claro: GREEN, escuro: DARK_GREEN },
  },
  '/app/backof': {
    itens: backoffice,
    tema: { claro: INDIGO, escuro: DARK_INDIGO },
  },
  '/app/rel': {
    itens: relatorios,
    tema: { claro: AMBER, escuro: DARK_AMBER },
  },
  '/app/dash': {
    itens: dashboards,
    tema: { claro: AMBER, escuro: DARK_AMBER },
  },
  '/app/com': {
    itens: comercial,
    tema: { claro: PINK, escuro: DARK_PINK },
  },
  '/app/config': {
    itens: configuracoes,
    tema: { claro: DEEP_ORANGE, escuro: DARK_DEEP_ORANGE },
  },
  '/app/digital': {
    itens: digital,
    tema: { claro: DEEP_PURPLE, escuro: DARK_DEEP_PURPLE },
  },
};

export function getModulePath(pathname) {
  const pos = pathname.indexOf('/', 6);
  return pos > 0 ? pathname.substring(0, pos) : pathname;
}

function getModulo(pathname) {
  return MODULOS[getModulePath(pathname)] || MODULO_PADRAO;
}

export function getTemaDoModulo(pathname) {
  return getModulo(pathname).tema;
}

export function getMenuDoModulo(pathname, podeAcessar, authUserInfo) {
  return [
    {
      name: 'Menu',
      type: 'section',
      children: getModulo(pathname).itens(podeAcessar, authUserInfo),
    },
  ];
}
